import { useAuth } from "components/Auth";
import { useAppSelector } from "redux/hooks";
import { ValidAuth } from "redux/reducers/auth/isAuth";
import ErrorBox from "components/blocks/error/ErrorBox";

export default function Notfound(): JSX.Element {
  const { isLogout, isAuthenticated }: ValidAuth = useAppSelector(
    (state) => state.isAuth
  );
  const { onForwardLogin } = useAuth();

  const onReturn = () => {
    if (!isLogout && !isAuthenticated) {
      onForwardLogin();
      return;
    }
    window.location.href = "/login";
  };
  return (
    <ErrorBox
      title="Error 404"
      subtitle="Page not found."
      onReturn={onReturn}
      message="Sorry, we couldn't find that page."
      buttonLabel="Return to myDW"
    >
      <p>
        The page you are looking for may have been moved, deleted, or does not
        exist.
        <br />
        <br />
        Click the button below to return to a working page on the site and
        resuming using myDW.
      </p>
    </ErrorBox>
  );
}
